import { DatePipe } from "@angular/common";
import { Component, ViewChild } from "@angular/core";
import { TombamentoService } from "administrativo-lib";
import { ProdutoService } from "almoxarifado-lib";
import { PlanoContaService } from "contabil-lib";
import { AssinaturaService, BaseResourceRptPersonalizadoComponent, Coluna, EddyAutoComplete, GlobalService, LicitacaoPipe, PlanoConta, Setor, SetorService, SituacaoPatrimonio, Tombamento } from "eddydata-lib";
import { MenuItem } from "primeng/api";
import { Panel } from "primeng/panel";
import { takeUntil } from "rxjs/operators";
import * as toastr from 'toastr';

@Component({
  selector: 'app-ficha-bens-rpt',
  templateUrl: './ficha-bens-rpt.component.html'
})
export class FichaBensRptComponent extends BaseResourceRptPersonalizadoComponent {

  @ViewChild('panel') painel: Panel;

  protected datepipe: DatePipe;
  public placaInicial: number;
  public placaFinal: number;
  public setor: Setor;
  public listaSetor: Setor[];
  public plano_conta: PlanoConta;
  public planoContaAutoComplete: EddyAutoComplete<PlanoConta>;
  public listaStatusPatrimonio: { id: SituacaoPatrimonio | 'TODOS', nome: string, estilo: string }[];
  public situacao: SituacaoPatrimonio | 'TODOS' = 'TODOS';

  public listaFiltros: Coluna[] = [];
  public menuFiltros: MenuItem[] = [];
  public imaskQtd = {
    mask: Number,
    scale: 0,
    signed: false
  };

  constructor(
    public produtoService: ProdutoService,
    private tombamentoService: TombamentoService,
    private setorService: SetorService,
    private planoContaService: PlanoContaService,
    protected assinaturaService: AssinaturaService,
  ) {
    super(assinaturaService);
    this.assinaturaObrigatoria = false;
    this.datepipe = new DatePipe('pt');
  }

  protected afterInit(): void {
    this.loadMenuFiltros(true);
    this.setorService.filtrar(0, 0, {
      orgao_id: this.login.orgao.id, orderBy: 'nome'
    }).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      this.listaSetor = res.content;
    })

    this.planoContaAutoComplete = new EddyAutoComplete(null, this.planoContaService, 'id', ['codigo', 'nome'], { exercicio_id: this.login.exercicio.id, }, { number: ['codigo'], text: ['nome'] });
    this.listaStatusPatrimonio = new GlobalService().obterSituacaoPatrimonio();
    this.listaStatusPatrimonio.unshift({ id: 'TODOS', nome: 'Todos', estilo: '' });
  }

  protected modalRelatorio(): string {
    return 'dialogRelatorioFichaBens';
  }

  protected tituloRelatorio(): string {
    return 'Ficha de Bens';
  }

  protected layoutRelatorio(): {} {
    return {
      table_eddy: {
        hLineWidth: function (i, node) {
          return i === node.table.body.length || i === 0 ? 0 : 1;
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i, node) {
          return i === node.table.headerRows || i === node.table.body.length - 1 ? 'black' : '#eee';
        },
        paddingLeft: function (i) {
          return i === 0 ? 0 : 8;
        },
        paddingRight: function (i, node) {
          return (i === node.table.widths.length - 1) ? 0 : 8;
        },
        fillColor: function (i, node) {
          if (i === 0 || i === node.table.headerRows || i === node.table.body.length - 1) {
            return null;
          }
          return (i % 2 === 0) ? '#f5f5f5' : null;
        }
      }
    }
  }

  protected async montarConteudo(): Promise<{}[]> {
    const conteudo = []
    const parametros = {}

    if (this.placaInicial) {
      if (this.placaFinal) {
        parametros['placa$ge'] = this.placaInicial
        parametros['placa$le'] = this.placaFinal
      } else {
        parametros['placa'] = this.placaInicial
      }
    }
    if (this.setor)
      parametros['setor_id'] = this.setor.id
    if (this.plano_conta)
      parametros['plano_conta.codigo'] = this.plano_conta.codigo
    if (this.situacao === 'TODOS') {
      parametros['situacao$ne'] = 'EXCLUIDO';
    } else {
      parametros['situacao'] = this.situacao;
    }

    Object.assign(parametros, this.obterFiltrosLista());

    if (Object.keys(parametros).length === 0) {
      toastr.warning('Nenhum filtro informado')
      return;
    }

    parametros['orgao_id'] = this.login.orgao.id;
    parametros['relations'] = 'produto,plano_conta,setor.unidade,localizacao,empenho.subelemento.plano,seguradora,favorecido';

    return await new Promise((resolve) => {
      this.tombamentoService.filtrar(0, 0, parametros).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          const tombos: Tombamento[] = res.content;
          for (let i = 0; i < tombos.length; i++) {
            const t = tombos[i]
            conteudo.push({
              pageBreak: `${i % 2 === 1 && i < tombos.length - 1 ? 'after' : ''}`,
              table: {
                widths: ['auto', 'auto', 'auto', '*'],
                body: [
                  [
                    {
                      text: [
                        { text: 'Placa\n', fontSize: 9, bold: true },
                        { text: t.placa, fontSize: 8, bold: false, alignment: 'right' },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Situação\n', fontSize: 9, bold: true },
                        { text: t.situacao, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Conservação\n', fontSize: 9, bold: true },
                        { text: t.conservacao, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Produto\n', fontSize: 9, bold: true },
                        { text: t.produto.nome, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                  ],
                  [
                    {
                      text: [
                        { text: 'Tipo Aquisição\n', fontSize: 9, bold: true },
                        { text: t.aquisicao, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Dt. Aquisição\n', fontSize: 9, bold: true },
                        { text: this.funcaoService.converteDataBR(t.data_aquisicao), fontSize: 8, bold: false },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Dt. Incorporaçao\n', fontSize: 9, bold: true },
                        { text: this.funcaoService.converteDataBR(t.data_cadastro), fontSize: 8, bold: false },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Conta Contábil\n', fontSize: 9, bold: true },
                        { text: t.plano_conta?.nome, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                  ],
                  [
                    {
                      text: [
                        { text: 'Marca\n', fontSize: 9, bold: true },
                        { text: t.marca, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Cor\n', fontSize: 9, bold: true },
                        { text: t.cor, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Medida\n', fontSize: 9, bold: true },
                        { text: t.medida, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Setor\n', fontSize: 9, bold: true },
                        { text: t.setor.nome, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                  ],
                  [
                    {
                      text: [
                        { text: 'Fornecedor\n', fontSize: 9, bold: true },
                        { text: `${t.favorecido?.id} - ${t.favorecido?.nome}`, fontSize: 8, bold: false },
                      ], margin: 2, colSpan: 4
                    }, '', '', ''
                  ],
                  [
                    {
                      text: [
                        { text: 'Vl. Aquisição\n', fontSize: 9, bold: true },
                        { text: this.funcaoService.convertToBrNumber(t.valor_aquisicao), fontSize: 8, bold: false, alignment: 'right' },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Vl. Avaliação\n', fontSize: 9, bold: true },
                        { text: this.funcaoService.convertToBrNumber(t.valor_avaliacao), fontSize: 8, bold: false, alignment: 'right' },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Vl. Atual\n', fontSize: 9, bold: true },
                        { text: this.funcaoService.convertToBrNumber(t.valor_atual), fontSize: 8, bold: false, alignment: 'right' },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Secretaria\n', fontSize: 9, bold: true },
                        { text: t.setor.unidade?.nome, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                  ],
                  [
                    {
                      text: [
                        { text: 'Vida Útil\n', fontSize: 9, bold: true },
                        { text: t.vida_util_meses, fontSize: 8, bold: false, alignment: 'right' },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Vl. Residual\n', fontSize: 9, bold: true },
                        { text: this.funcaoService.convertToBrNumber(t.valor_residual), fontSize: 8, bold: false, alignment: 'right' },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Vl. Depreciado\n', fontSize: 9, bold: true },
                        { text: this.funcaoService.convertToBrNumber(t.valor_depreciado), fontSize: 8, bold: false, alignment: 'right' },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Localização\n', fontSize: 9, bold: true },
                        { text: t.localizacao?.localizacao, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                  ],
                  [
                    {
                      text: [
                        { text: 'Empenho\n', fontSize: 9, bold: true },
                        { text: t.empenho?.numero, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Documento\n', fontSize: 9, bold: true },
                        { text: t.documento, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Processo\n', fontSize: 9, bold: true },
                        { text: new LicitacaoPipe().transform(t.processo), fontSize: 8, bold: false },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Sub-Elemento\n', fontSize: 9, bold: true },
                        { text: t.empenho?.subelemento?.plano?.nome, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                  ],
                  /*
                  [
                    {
                      text: [
                        { text: 'Nº Apólice\n', fontSize: 9, bold: true },
                        { text: t.numero_apolice, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Vcto. Seguro\n', fontSize: 9, bold: true },
                        { text: this.funcaoService.converteDataBR(t.vencimento_seguro), fontSize: 8, bold: false },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Vcto. Garantia\n', fontSize: 9, bold: true },
                        { text: this.funcaoService.converteDataBR(t.vencimento_garantia), fontSize: 8, bold: false },
                      ], margin: 2
                    },
                    {
                      text: [
                        { text: 'Seguradora\n', fontSize: 9, bold: true },
                        { text: t.seguradora?.nome, fontSize: 8, bold: false },
                      ], margin: 2
                    },
                  ],
                  [
                    {
                      text: [
                        { text: 'Observação\n', fontSize: 9, bold: true },
                        { text: t.obs, fontSize: 8, bold: false },
                      ], margin: 2, colSpan: 4
                    },
                  ],
                  */
                ]
              }
            });
            conteudo.push({ text: '', margin: 10 })
          }

          conteudo.push({ text: `Total de bens: ${tombos.length}`, margin: 10, bold: true, fontSize: 12 })

          resolve(conteudo)
        });
    });
  }

  //***********************FILTRO PERSONALIZADO *************************//
  protected obterColunasfiltroPersonalizado(): Coluna[] {
    const retorno: Coluna[] = [];

    retorno.push({
      titulo: 'Item', coluna: 'produto.id', tipo: 'AutoComplete', autocomplete: new EddyAutoComplete(null, this.produtoService,
        'id', ['codigo', 'nome'], { orgao_id: this.login.orgao.id, inativo: false, orderBy: 'codigo,nome' }, { number: ['codigo'], text: ['codigo', 'nome'] }
      ), cols: 12
    });
    retorno.push({
      titulo: 'Tipo de aquisição', coluna: 'aquisicao', tipo: 'Selection', opcoesSelecao: [
        { valor: 'COMPRA', label: 'Compra' },
        { valor: 'PERMUTA', label: 'Permuta' },
        { valor: 'DOACAO', label: 'Doação' },
        { valor: 'CESSAO', label: 'Cessão de uso' },
        { valor: 'IMPLANTACAO', label: 'Implementação' },
        { valor: 'FABRICACAO', label: 'Fabricação' },
        { valor: 'REINTEGRACAO', label: 'Reintegração' },
        { valor: 'AVALIACAO', label: 'Avaliação' },
      ], cols: 6
    });

    return retorno;
  }

  private loadMenuFiltros(init?: boolean) {
    let filtros = this.obterColunasfiltroPersonalizado();
    this.menuFiltros = filtros.map((l): MenuItem => {
      if (!l['filtro1'])
        l['filtro1'] = null;
      if (!l['filtro2'])
        l['filtro2'] = null;
      return {
        label: l.titulo,
        icon: this.iconMenu(l),
        visible: !this.filtroAdicionado(l),
        command: (event) => {
          this.adicionarFiltro(l);
        }
      };
    });
  }

  private adicionarFiltro(coluna: Coluna) {
    if (!this.filtroAdicionado(coluna)) {
      if (coluna.tipo === 'Boolean') {
        coluna['filtro1'] = coluna.value ? coluna.value : false;
      }
      this.listaFiltros.push(coluna);
      if (this.painel) {
        this.painel.expand(null);
      }
    }
    this.loadMenuFiltros();
  }

  public filtroAdicionado(coluna: Coluna): boolean {
    let filtro = this.listaFiltros.find((f) => f.coluna === coluna.coluna);
    return !(!filtro);
  }

  public removerFiltro(coluna: Coluna) {
    let index = this.listaFiltros.indexOf(coluna);
    if (index || index === 0) this.listaFiltros.splice(index, 1);
    this.loadMenuFiltros();
  }

  private obterFiltrosLista(): {} {
    let filtros: {} = {};
    try {
      for (let filtro of this.listaFiltros) {
        let convert = this.converterFiltro(filtro);
        if (convert) {
          if (!convert['length']) {
            filtros[convert['chave']] = convert['valor'];
          } else {
            for (let fs of <[]>convert) {
              filtros[fs['chave']] = fs['valor'];
            }
          }
        }
      }
      return filtros;
    } catch (error) {
      this.funcaoService.acaoErro(error);
      return null;
    }
  }

  public semExluirStyle(filtro: any, style: any) {
    if (filtro.semExcluir)
      return { width: '100%' };
    return style;
  }

  private converterFiltro(coluna: Coluna): { chave: string, valor: string } | { chave: string, valor: string }[] {
    if (coluna.tipo === 'Number' && coluna['filtro1']) {
      if (coluna['filtro1'] && !coluna['filtro2']) {
        return { chave: `${coluna.coluna}$like`, valor: coluna['filtro1'] + '%' }
      }
      let filtro_data = [];
      if (coluna['filtro1']) {
        filtro_data.push({ chave: `${coluna.coluna}$ge`, valor: coluna['filtro1'] });
      }
      if (coluna['filtro2']) {
        filtro_data.push({ chave: `${coluna.coluna}$le`, valor: coluna['filtro2'] });
      }
      return filtro_data;
    }

    if (coluna.tipo === 'String' && coluna['filtro1']) {
      return { chave: `${coluna.coluna}$like`, valor: `%${coluna['filtro1']}%` };
    }

    if (coluna.tipo === 'Boolean' && coluna['filtro1']) {
      return { chave: coluna.coluna, valor: coluna['filtro1'] };
    }

    if (coluna.tipo === 'Date') {
      let filtro_data = [];
      if (coluna['filtro1'])
        filtro_data.push({ chave: `${coluna.coluna}$ge`, valor: this.datepipe.transform(coluna['filtro1'], 'yyyy-MM-dd') });
      if (coluna['filtro2'])
        filtro_data.push({ chave: `${coluna.coluna}$le`, valor: this.datepipe.transform(coluna['filtro2'], 'yyyy-MM-dd') });
      return filtro_data.length > 0 ? filtro_data : null;
    }

    if (coluna.tipo == 'Selection' && coluna['filtro1']) {
      return { chave: `${coluna.coluna}$eq`, valor: coluna['filtro1'] };
    }

    if (coluna.tipo === 'AutoComplete' && coluna.autocomplete && coluna['filtro1']) {
      return { chave: coluna.coluna, valor: coluna['filtro1'][coluna.autocomplete.campoChave] };
    }

    return null;
  }

  public filtroTipo(filtro: Coluna[], tipo: 'String' | 'Number' | 'Date' | 'Boolean' | 'HTML') {
    return filtro.filter((f) => f.tipo === tipo);
  }

  public ngClassCols(cols: number, padrao: string): {} {
    let ngClass = {};
    if (cols) {
      ngClass[`col-sm-${cols}`] = true;
    } else {
      ngClass[padrao] = true;
    }
    return ngClass;
  }

  private iconMenu(coluna: Coluna) {
    let icon = 'plus';
    if (coluna.tipo === 'Date')
      icon = 'calendar';
    if (coluna.tipo === 'Number')
      icon = 'calculator';
    if (coluna.tipo === 'String')
      icon = 'font';
    if (coluna.tipo === 'Boolean')
      icon = 'check';
    if (coluna.tipo === 'Selection') {
      icon = 'list';
    }
    return `fa fa-${icon}`;
  }

}